const NotFound = () => {
    return (
        <h1>ERROR 404: Page Not Found</h1>
    );
}

export default NotFound;
